// tslint:disable:no-magic-numbers

const regexPaths = /[^|\/]([\#]?[0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?/g;
const regexPath = /^([\#]?[0-9a-zA-Z\-\_\.]+)(\[(\d+)\])?$/;

export class Selector {
    public static parsePath(path: string) {
        return path.match(regexPaths).map((p) => new Selector(p));
    }
    public readonly identifier: string;
    public readonly num: number;

    public constructor(
        selector: string,
    ) {
        const parsed = regexPath.exec(selector);
        this.identifier = parsed[1];
        this.num = parsed[3] ? parseInt(parsed[3], 10) : 1;
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/Selector.tsx